import React, { useEffect, useState } from "react";
import { Box, Dialog, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { color } from "../StyleData/Config";
import NormalTable from "./NormalTable";
import { fromUTC } from "../utils/dateUtil";
import { encode } from "./JWT/Formatt";
import CreateWO from "../Pages/WorkManagement/WorkOrder/WO";

const DynamicWoList = ({
    apiData = [],
    status = "",
    title = "Work Orders",
    extraColumns = [],
}) => {
    const [data, setData] = useState([]);
    const [create, setCreate] = useState(false);
    const [mode, setMode] = useState("");
    const [editData, setEditData] = useState({});

    useEffect(() => {
        getData();
    }, [apiData, status]);

    const getData = () => {
        const filteredData = apiData.filter(
            (item) => item.status === status,
        );

        setData(filteredData);
    };

    const handleCreateClose = () => {
        setMode("");
        setCreate(false);
        getData();
    };

    const defaultColumns = [
        {
            Header: "WO Code",
            accessor: "code",

            Cell: ({ cell }) => {
                return (
                    <Link
                        to={`/redirectwo?id=${encode(cell.row.original.id)}`}
                        style={{
                            color: "#0d6efd",
                            textDecorationLine: "underline",
                            fontWeight: 800,
                        }}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {cell.value}
                    </Link>
                );
            },
        },

        {
            Header: "WO Name",
            accessor: "workOrderName",
        },

        {
            Header: "Planned Start Date",
            accessor: "plannedStartDate",

            Cell: ({ cell }) => {
                return cell.value
                    ? fromUTC(cell.value).tzString
                    : "-";
            },
        },

        {
            Header: "Planned End Date",
            accessor: "plannedEndDate",

            Cell: ({ cell }) => {
                return cell.value
                    ? fromUTC(cell.value).tzString
                    : "-";
            },
        },

        {
            Header: "Status",
            accessor: "status",
        },
    ];

    const columns = [...defaultColumns, ...extraColumns];

    return (
        <>
            <Box>
                <Typography
                    sx={{
                        color: color.masterPageTitleColor,
                        fontSize: color.masterPageTitleFontSize,
                        fontWeight: color.masterPageTitleFontWeight,
                        mb: color.masterPageTitlemd,
                        px: 2,
                        py: 1,
                    }}
                >
                    {title}
                </Typography>
            </Box>

            <Box
                sx={{
                    px: 2,
                    py: 1,
                }}
            >
                <NormalTable
                    data={data}
                    columns={columns}
                    filt={true}
                />
            </Box>

            <Dialog
                open={create}
                onClose={handleCreateClose}
                maxWidth={"md"}
            >
                <CreateWO
                    handleCloseClick={handleCreateClose}
                    mode={mode}
                    editData={editData}
                />
            </Dialog>
        </>
    );
};

export default DynamicWoList;